import { clear_token } from "@/router";
import { client_domain } from "@/main.js";

export default {
    props: {
      variant: {
        type: String,
        default: 'desktop',
      },
    },
    mounted() {
      this.initSidebar();
      this.$el.addEventListener('click', this.closeMobileSidebarOnNavigation);
      if (!this.isMobile && window.MutationObserver) {
        this.sidebarClassObserver = new MutationObserver(() => {
          const isExternallyClosed = this.$el.classList.contains('close');
          if (this.isClosed !== isExternallyClosed) {
            this.isClosed = isExternallyClosed;
          }
        });
        this.sidebarClassObserver.observe(this.$el, { attributes: true, attributeFilter: ['class'] });
      }
      if(client_domain.includes('cbo')){
        this.cbo_domain=true
      }
      if(client_domain.includes('cbo')){
        this.cbo_domain=true
      }
      if (client_domain.includes('workbook')) {
        this.workbook_domain = true;
      }
      if (client_domain.includes('chiefluthuli')){
        this.school_domain = true;
      }
      if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
        this.dwypd_domain = true;
      }
    },

  data() {
    return ({
      isClosed: false,
      cbo_domain:false,
      workbook_domain: false,
      school_domain: false,
      dwypd_domain: false,
      sidebarClassObserver: null,
    });
  },

    inject: ['client_features'],
    computed: {
      isMobile() {
        return this.variant === 'mobile';
      },
    },
    beforeDestroy() {
      this.destroySidebarListeners();
    },
    beforeUnmount() {
      this.destroySidebarListeners();
    },
    methods: {
      destroySidebarListeners() {
      this.$el.removeEventListener('click', this.closeMobileSidebarOnNavigation);
      if (this.sidebarClassObserver) {
        this.sidebarClassObserver.disconnect();
        this.sidebarClassObserver = null;
      }
      },
      toggle() {
        this.isClosed = !this.isClosed;
      },
      initSidebar() {
        let arrows = document.querySelectorAll(".arrow");
        arrows.forEach(arrow => {
          arrow.addEventListener("click", (e) => {
            let arrowParent = e.target.parentElement.parentElement;
            arrowParent.classList.toggle("show-menu");
          });
        });
      },
      log_out(){
        clear_token()
        this.$router.push({ path:'/',});
      },
      closeMobileSidebarOnNavigation(event) {
        if (!this.isMobile || !event.target.closest('a')) {
          return;
        }

        const offcanvas = window.bootstrap?.Offcanvas?.getInstance(this.$el);
        if (offcanvas) {
          offcanvas.hide();
        }
      }
    }
  }
